import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedDate',
  pure: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(
  ) {}

  transform(value: any, pattern: string = 'mediumDate', timezone?: string): any {
    const datePipe: DatePipe = new DatePipe(this.getLanguageAndCulture());
    return datePipe.transform(value, pattern, timezone);
  }

  getLanguageAndCulture() {
    const lang = localStorage.getItem('lang') || 'en';
    const culture = localStorage.getItem('culture') || 'GB';
    return lang + '-' + culture;
  }
}
